import { Route } from "react-router-dom";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../../Pages/Users/Roles/UserSecurityFind";
import Reports from "../../Pages/Reports/Reports";
import DashboardTemplate from "../../Template/DashboardTemplate";
import ResourceNotFound from "../ResourceNotFound";
import { ItemRoutesProps } from "./PageRoute";
import BRSReport from "../../Pages/Reports/BankReconciliation/BRSReport";
import FAR from "../../Pages/Reports/FixedAssetsRegister/FAR";
import TrialBalanceNew from "../../Pages/Reports/TrialBalance/TrialBalanceNew";
import PartyOutstanding from "../../Pages/Reports/PartyOutstanding/PartyOutstanding";
import Ageing from "../../Pages/Reports/Ageing/Ageing";
import {
  AgeingReportTypes,
  Statements,
} from "../../Services/ReportsServiceNew";
import GSTReports from "../../Pages/Reports/GSTReports/GSTReports";
import ProfitAndLossNew from "../../Pages/Reports/Profit&LossAndBalanceSheet/ProfitAndLossNew";
import GeneralLedger from "../../Pages/Reports/GeneralLedger/GeneralLedger";

const ReportRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      <Route
        path={`/${currentClient?.id}/Reports/*`}
        element={
          findUserPremission(
            [
              "Report.BalanceSheet.View",
              "Report.P&L.View",
              "Report.TrialBalance.View",
              "Report.CashFlow.View",
              "Report.DebtorsAgeing.View",
              "Report.CreditorsAgeing.View",
              "Report.CustomerOutstanding.View",
              "Report.SupplierOutstanding.View",
              "Report.GeneralLedger.View",
              "Report.FixedAssets.View",
              "Report.BankReconciliation.View",
              "Report.GST.View",
              "Report.Tds.View",
              "Report.Tcs.View",
            ],
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<Reports />}
              breadcrumprops={[
                {
                  item: "Reports",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* ----------- Financial Reports  ----------- */}
      {/* Profit & Loss Route */}
      <Route
        path={`/${currentClient?.id}/reports/profitAndLoss/*`}
        element={
          findUserOnlyOnePremission(
            "Report.P&L.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<ProfitAndLossNew type={Statements.ProfitAndLoss} />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Profit And Loss",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/*  Balance Sheet Route */}
      <Route
        path={`/${currentClient?.id}/reports/balanceSheet/*`}
        element={
          findUserOnlyOnePremission(
            "Report.BalanceSheet.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<ProfitAndLossNew type={Statements.BalanceSheet} />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Balance Sheet",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Trial Balance Route */}
      <Route
        path={`/${currentClient?.id}/reports/trialbalancenew/*`}
        element={
          findUserOnlyOnePremission(
            "Report.TrialBalance.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<TrialBalanceNew />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Trial Balance",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Payables and Receivables Reports ----------- */}
      {/* ageing */}
      <Route
        path={`/${currentClient?.id}/reports/ageing/debtors`}
        key="ageing"
        element={
          findUserOnlyOnePremission(
            "Report.DebtorsAgeing.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<Ageing SelType={AgeingReportTypes.Debtors} />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Ageing Report",
                  path: `/billing/clients/${currentClient?.id}/reports/ageing/debtors`,
                },
                {
                  item: "Debtors",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`/${currentClient?.id}/reports/ageing/creditors`}
        key="ageing"
        element={
          findUserOnlyOnePremission(
            "Report.CreditorsAgeing.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<Ageing SelType={AgeingReportTypes.Creditors} />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Ageing Report",
                  path: `/billing/clients/${currentClient?.id}/reports/ageing/creditors`,
                },
                {
                  item: "Creditors",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Party Outstanding */}
      <Route
        path={`/${currentClient?.id}/reports/partyOutstanding/customer`}
        key="ageing"
        element={
          findUserOnlyOnePremission(
            "Report.CustomerOutstanding.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<PartyOutstanding Type={0} />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Customer Outstanding",
                  // path: `/billing/clients/${currentClient?.id}/reports/partyOutstanding/customer`,
                },
                // {
                //   item: "Customer Outstanding",
                // },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`/${currentClient?.id}/reports/partyOutstanding/supplier`}
        key="ageing"
        element={
          findUserOnlyOnePremission(
            "Report.SupplierOutstanding.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<PartyOutstanding Type={1} />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Supplier Outstanding",
                  // path: `/billing/clients/${currentClient?.id}/reports/partyOutstanding/supplier`,
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- General ----------- */}
      <Route
        path={`/${currentClient?.id}/reports/generalLedger/*`}
        element={
          findUserOnlyOnePremission(
            "Report.GeneralLedger.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<GeneralLedger />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "General ledger",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Fixed Assets Register */}
      <Route
        path={`/${currentClient?.id}/reports/far/*`}
        element={
          findUserOnlyOnePremission(
            "Report.FixedAssets.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<FAR />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Fixed Assets Register",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Bank Reconciliation Report */}
      <Route
        path={`/${currentClient?.id}/reports/brsReports/*`}
        element={
          findUserOnlyOnePremission(
            "Report.BankReconciliation.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<BRSReport />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "Bank Reconciliation",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* GST Reports */}
      <Route
        path={`/${currentClient?.id}/reports/GSTReports/*`}
        element={
          findUserOnlyOnePremission(
            "Report.GST.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<GSTReports />}
              breadcrumprops={[
                {
                  item: "Reports",
                  path: `/billing/clients/${currentClient?.id}/reports`,
                },
                {
                  item: "GST Report",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
    </>
  );
};

export default ReportRoute;
